import en from './en';
import vi from './vi';
import id from './id';
import th from './th';
import ph from './ph';

const resource = { en, vi, id, th, ph };

export default resource;
